export default __webpack_public_path__ + "static/media/think_and_grow_rich_book.95c523b4.jpg";